const WorkerService = {
  install (Vue) {
    Vue.prototype.$worker = {
      reset: (form) => {
        for (const key in form) {
          // eslint-disable-next-line no-prototype-builtins
          if (form.hasOwnProperty(key)) {
            form[key] = null
          }
        }
        return form
      }
    }
  }
}

export default (WorkerService)
